import React from 'react';

interface Props {
  id: string;
  children: React.ReactNode;
}

class ModalSidebar extends React.Component<Props> {
  render(): React.ReactNode {
    const { id, children } = this.props;

    return (
      <div
        id={id}
        className="column bgd-light-grey-2 shrink-0 b-solid b-width-0 b-transparent oh"
        style={{ width: '366px', borderRadius: '8px 8px 0 0' }}
      >
        {children}
      </div>
    );
  }
}

export default ModalSidebar;
